import React, { useEffect, useState } from 'react';
import { InlineGrid, Select, TextField } from '@shopify/polaris';
import { useDebounced } from '../ItAssets/common';
import { IMAGE_OPTIONS } from './routes';

const CERT = [
  { value: '', label: 'Any certainty' }, { value: '80-', label: '80 and up' },
  { value: '60-79', label: '60–79' }, { value: '-59', label: 'Under 60' },
];
const TRI = (a, b) => [{ value: '', label: 'any' }, { value: 'true', label: a }, { value: 'false', label: b }];
const STATUSES = ['proposed', 'edited', 'approved', 'written', 'failed', 'none'];

// certainty_min / certainty_max <-> one of the presets above.
const certValue = (s) => (s.certainty_min || s.certainty_max ? `${s.certainty_min}-${s.certainty_max}` : '');

export default function ReviewFilters({ state, set, facets }) {
  const [q, setQ] = useState(state.q);
  const dq = useDebounced(q);
  useEffect(() => { if (dq !== state.q) set({ q: dq }); }, [dq]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setQ(state.q); }, [state.q]);          // back / forward moves the address; the box follows
  const [vendor, setVendor] = useState(state.vendor);
  const dv = useDebounced(vendor);
  useEffect(() => { if (dv !== state.vendor) set({ vendor: dv }); }, [dv]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setVendor(state.vendor); }, [state.vendor]);
  const facetOptions = [{ value: '', label: 'Any' }, ...(facets || []).filter((f) => f.id !== 'category').map((f) => ({ value: f.id, label: f.label || f.id }))];
  return (
    <InlineGrid columns={{ xs: 1, sm: 2, md: 3, lg: 5 }} gap="300">
      <TextField label="Search" labelHidden value={q} onChange={setQ} placeholder="Search title, handle, vendor…" autoComplete="off" clearButton onClearButtonClick={() => setQ('')} />
      <Select label="Certainty" labelHidden options={CERT} value={certValue(state)}
        onChange={(v) => { const [lo, hi] = v.split('-'); set({ certainty_min: lo || '', certainty_max: hi || '' }); }} />
      <Select label="Category" labelHidden options={[{ value: '', label: 'Category: any' }, { value: 'true', label: 'Category changed' }, { value: 'false', label: 'Category kept' }]}
        value={state.category_changed} onChange={(v) => set({ category_changed: v })} />
      <Select label="Conflicts" labelHidden options={TRI('Has conflict', 'No conflict').map((o) => (o.value ? o : { value: '', label: 'Conflicts: any' }))}
        value={state.has_conflict} onChange={(v) => set({ has_conflict: v })} />
      <Select label="Has a value for" labelHidden options={facetOptions.map((o) => (o.value ? o : { value: '', label: 'Facet filled: any' }))}
        value={state.facet} onChange={(v) => set({ facet: v })} />
      <TextField label="Vendor" labelHidden value={vendor} onChange={setVendor} placeholder="Vendor (exact)" autoComplete="off" clearButton onClearButtonClick={() => setVendor('')} />
      <Select label="Status" labelHidden options={[{ value: '', label: 'Any status' }, ...STATUSES.map((s) => ({ value: s, label: s }))]}
        value={state.status} onChange={(v) => set({ status: v })} />
      <Select label="AI" labelHidden options={[{ value: '', label: 'AI: any' }, { value: 'done', label: 'AI answered' }, { value: 'checked', label: 'AI checked, nothing to ask' }, { value: 'none', label: 'Not through AI yet' }]}
        value={state.ai || ''} onChange={(v) => set({ ai: v })} />
      <Select label="Image" labelHidden options={IMAGE_OPTIONS} value={state.image || 'with'} onChange={(v) => set({ image: v })} />
    </InlineGrid>
  );
}
